import { addLocaleData } from 'react-intl';
import _ from "lodash";

import pl from './messages/pl';
import en from './messages/en';
import de from './messages/de';
import es from './messages/es';
import it from './messages/it';
import nl from './messages/nl';
import ru from './messages/ru';
import sk from './messages/sk';
import uk from './messages/uk';
import cs from './messages/cs';
import ro from './messages/ro';
import fr from './messages/fr';
import hu from './messages/hu';

require('@formatjs/intl-pluralrules/polyfill')
require('@formatjs/intl-pluralrules/locale-data/pl')
require('@formatjs/intl-pluralrules/locale-data/en')
require('@formatjs/intl-pluralrules/locale-data/de')
require('@formatjs/intl-pluralrules/locale-data/es')
require('@formatjs/intl-pluralrules/locale-data/it')
require('@formatjs/intl-pluralrules/locale-data/nl')
require('@formatjs/intl-pluralrules/locale-data/ru')
require('@formatjs/intl-pluralrules/locale-data/sk')
require('@formatjs/intl-pluralrules/locale-data/uk')
require('@formatjs/intl-pluralrules/locale-data/cs')
require('@formatjs/intl-pluralrules/locale-data/ro')
require('@formatjs/intl-pluralrules/locale-data/fr')
require('@formatjs/intl-pluralrules/locale-data/hu')

require('@formatjs/intl-relativetimeformat/polyfill')
require('@formatjs/intl-relativetimeformat/locale-data/pl')
require('@formatjs/intl-relativetimeformat/locale-data/en')
require('@formatjs/intl-relativetimeformat/locale-data/de')
require('@formatjs/intl-relativetimeformat/locale-data/es')
require('@formatjs/intl-relativetimeformat/locale-data/it')
require('@formatjs/intl-relativetimeformat/locale-data/nl')
require('@formatjs/intl-relativetimeformat/locale-data/ru')
require('@formatjs/intl-relativetimeformat/locale-data/sk')
require('@formatjs/intl-relativetimeformat/locale-data/uk')
require('@formatjs/intl-relativetimeformat/locale-data/cs')
require('@formatjs/intl-relativetimeformat/locale-data/ro')
require('@formatjs/intl-relativetimeformat/locale-data/fr')
require('@formatjs/intl-relativetimeformat/locale-data/hu')

export const messagesLangs = {
  en,
  pl,
  de,
  es,
  it,
  nl,
  ru,
  sk,
  uk,
  cs,
  ro,
  fr,
  hu,
};

if(_.isEmpty(localStorage.surveyLanguage)){
  localStorage.surveyLanguage = navigator.language ? navigator.language.split('-')[0] : 'pl';
}

let navlang = localStorage.surveyLanguage;

const html = document.getElementsByTagName('html');
if (html && html.length > 0 && location.href.includes("lang=") === false) {
  if (Object.keys(messagesLangs).includes(html[0].getAttribute('navlang'))) {
    navlang = html[0].getAttribute('navlang')
  }
}

export default {
  locale: localStorage.surveyLanguage,
  messages: messagesLangs[navlang]
}
